<template>

	<div>
		<layout :mastheadBackgroundImage="require('img/mastheads/webinars2.jpg')">
			<div slot="masthead" class="center">
				<masthead>
					<template slot="headline">Sign up for a free webinar</template>
					<template slot="content">
						<span style="font-weight:600;">
							Register below for upcoming free sessions designed to support educators using or interested in StudySync and SyncBlasts. After each live event, registrants receive a recording of the webinar for review.
<br><br>
							For even more professional development and learning options, explore your <a href="https://apps.studysync.com/#!/public/pd-video?pd=197" target="_blank">StudySync Help Center</a> or connect with <a href="https://content.studysync.com/support/07/Meet_the_StudySync_Implementation_Team.pdf" target="_blank">your local specialist</a> by emailing us at <a href="mailto:implementation@studysync.com">implementation@studysync.com</a>.
						</span>
					</template>
				</masthead>
			</div>
			<div class="content" slot="body">
				<template v-if="ready">
					<router-view v-bind="{ webinars }"></router-view>
				</template>
				<template v-else>
					<div class="loading">
						<Spinner class="spinner" />
					</div>
				</template>
			</div>
			<template slot="footer">
				<FooterCTA />
			</template>
		</layout>
	</div>
</template>

<script>

	import ViewAllView from './_view-all'
	import Layout from '@/layouts/layoutA'
	import Masthead from '@/layouts/layoutA/masthead'
	import FooterCTA from '@/components/FooterCTA'
	import Spinner from '@/components/Spinner'

	export default {
		routeConfig: {
			name: null,
			children: [
				{ name: 'webinars', path: '', component: ViewAllView },
				{ name: 'webinarsViewAll', path: 'view-all', redirect: { name: 'webinars' } }
			]
		},
		components: { Layout, Masthead, FooterCTA, Spinner },
		data: () => ({
			ready: false
		}),
		async created () {
			await this.$store.dispatch(`entities/webinar/fetchAll`)
			this.ready = true
		},
		computed: {
			webinars () {
				return this.$store.getters['entities/webinar/query']().withAll().get()
			}
		},
		metaInfo () {
			return this.$generateMetaInfo({
				title: `StudySync Webinars`,
				description: `StudySync offers a variety of free webinars. We recommend Basic Training webinars before Deeper Dive sessions. Sign up now, or contact us if you're interested in a custom webinar or Q & A session with a live implementation specialist.`,
				image: 'https://www.studysync.com/static/img/webinars1.8ac3b16.jpg'
			})
		}
	}

</script>

<style lang="scss" scoped>

	@import "media";

	.webinar-select {
		display:flex; align-items:center; justify-content:center; margin-top:1.5rem;
		@include media(small, large) {
			padding:0 5vw; flex-direction:column;
		}
		@include media(large) {
			margin:1.5em 0 -4em;
		}
		a {
			text-decoration:none; color:#FDB913; font-size:20px; font-weight:600; line-height:1.25; padding:3rem 2.5rem 3rem; position:relative; text-align:center;
			@include media(large) {
				margin-bottom:3.9rem;
			}
			&:first-child {
				@include media(large) {
					margin-right:5.5rem;
				}
			}
			&.router-link-active {
				color:#3D3D3D; background:#ffffff; border-radius:.5rem;
				&:after {
					@include media(large) {
						content:''; width:0; height:0; border-left:8px solid transparent; border-right:8px solid transparent; border-top:8px solid #ffffff; position:absolute; bottom:0; transform:translate(-100%, 100%);
					}
				}
				span {
					color:#6D6E71;
				}
			}
		}
		span {
			display:block; font-size:1.6rem; line-height:1.5; color:#ffffff; margin-top:1rem;
		}
	}

	.loading {
		margin:5rem 0;
		.spinner {
			margin:0 auto;
		}
	}

</style>



// WEBPACK FOOTER //
// src/routes/webinars/index.vue